export const NOTIFICATION_KEYS = {
  LOCATIONS_IMPORT_PENDING: "locations_import_pending"
};
